import React, { Component } from 'react';
import FlagChoice from './FlagChoice';
import FlagAnswer from './FlagAnswer';

class FlagGame extends Component {
  constructor() {
    super();
    this.state = {
      countries: [],
      selectedCountries: [],
      answerIndex: -1,
      selectedAnswer: -1,
      correctGuess: false,
      incorrectGuess: false,
    };
    this.onNewGame = this.onNewGame.bind(this);
    this.handleGuess = this.handleGuess.bind(this);
  }

  componentDidMount() {
    const apiUrl = 'https://restcountries.eu/rest/v2/all';
    fetch(apiUrl)
      .then(data => data.json())
      .then(data => this.setState({countries: data}, () => {
        this.onNewGame();
      }));
  }

  onNewGame() {
    const selectedCountries = this.getRandomCountries();
    const answerIndex = Math.floor(Math.random() * selectedCountries.length);
    this.setState({selectedCountries, answerIndex, selectedAnswer: -1, correctGuess: false});
  }

  getRandomCountries() {
    let index = 0;
    const result = [];
    while (index < 4)
      result[index++] = this.state.countries[Math.floor(Math.random() * this.state.countries.length)];

    return result;
  }

  handleGuess(selectedIndex) {
    if (selectedIndex === Number(this.state.answerIndex)) {
      this.setState({correctGuess: true, incorrectGuess: false});
    } else {
      this.setState({incorrectGuess: true});
    }
  }

  render() {
    let view = <div>Loading...</div>;
    const imgStyle = {
      maxWidth: '500px',
      border: '1px solid rgba(0,0,0,.5)',
      marginTop: '20px',
    };
    const divStyle = {
      padding: '20px',
    };
    if (this.state.selectedCountries.length > 0) {
      view = (
        <div style={divStyle}>
          {
            this.state.correctGuess &&
            <FlagAnswer answer={this.state.selectedCountries[Number(this.state.answerIndex)].name} onNewGame={this.onNewGame} />
          }
          {
            this.state.incorrectGuess && <h4 className="incorrect-guess">Incorrect guess</h4>
          }

          {!this.state.correctGuess &&
            <FlagChoice countries={this.state.selectedCountries} onSubmit={this.handleGuess}/>
          }
          <div>
            <img style={imgStyle} src={this.state.selectedCountries[this.state.answerIndex].flag} alt=""/>
          </div>
        </div>
      );
    }
    return view;
  }
}

export default FlagGame;



// WEBPACK FOOTER //
// ./src/FlagGame.jsx